import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenerationInProgressPopupComponent } from './generation-in-progress-popup.component';

import { MwcSpinModule } from 'mwc/spin';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { MwcFormModule } from 'mwc/form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MwcInputModule } from 'mwc/input';
import { MwcButtonModule } from 'mwc/button';




@NgModule({
  declarations: [
    GenerationInProgressPopupComponent
  ],
  imports: [
    CommonModule,
    MwcSpinModule,
    MwcFormModule,
    MwcInputModule,
    MwcButtonModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselModule.forRoot(),
  ],
  exports: [GenerationInProgressPopupComponent]
})
export class GenerationInProgressPopupModule { }
